import { IFrequencyCap } from '../entities/frequency-caps';
import { SiteSettingsApiEndpoints } from '../../utils/api-endpoints';
import { get } from 'core/network/RestApi';
import { generatePath } from 'react-router';

export const getFrequencyCapsList = async (siteId: string): Promise<IFrequencyCap[]> => {
  try {
    const result = await get<IFrequencyCap[]>(generatePath(SiteSettingsApiEndpoints.GET_FREQ_CAPS_LIST, { siteId }));

    return result?.data ?? [];
  } catch (e) {
    return [];
  }
};
